module.exports = __webpack_public_path__ + "img/programme1.e7afc416.png";